(function () {
  'use strict';
  if (window.PdpDesignLinks) return;
  function resolve(sources, options = {}) {
    const params = new URLSearchParams(window.location.search);
    const design = params.get('design'), variant = params.get('variant');
    const matching = sources.filter(source => design && source.handle === design);
    let selected = matching.find(source => source.variant != null && String(source.variant) === variant) || matching[0];
    if (!selected && options.legacyIndex && /^\d+$/.test(design || ''))
      selected = sources.find(source => source.designIndex === Number(design) && source.colorway == null);
    if (!selected && options.legacyKey)
      selected = sources.find(source => source.key && source.key === params.get(options.legacyKey));
    if (!selected && variant) selected = sources.find(source => source.variant != null && String(source.variant) === variant);
    const path = options.path || window.location.pathname;
    return selected || sources.find(source => source.url && new URL(source.url, window.location.origin).pathname === path) || sources[0] || null;
  }
  function waitImage(image) {
    if (!image) return Promise.resolve(false);
    // In hidden editor previews decode() can remain pending after the image
    // has loaded. Use the resource's load state rather than a paint/decode gate.
    return new Promise(resolve => {
      let timer, settled = false;
      const finish = ready => {
        if (settled) return;
        settled = true;
        clearTimeout(timer);
        image.removeEventListener('load', loaded);
        image.removeEventListener('error', failed);
        resolve(ready);
      };
      const loaded = () => finish(image.naturalWidth > 0);
      const failed = () => finish(false);
      image.addEventListener('load', loaded);
      image.addEventListener('error', failed);
      if (image.complete) { loaded(); return; }
      timer = setTimeout(() => finish(image.complete && image.naturalWidth > 0), 12000);
    });
  }

  function finish(section, ready) {
    if (!section) return;
    section.removeAttribute('data-design-initializing');
    if (ready) section.removeAttribute('data-design-media-pending');
    else section.setAttribute('data-design-media-pending', '');
    const status = document.getElementById(section.id + '-design-status');
    if (status) status.hidden = ready;
  }
  // Warm the browser cache so a design click swaps from cache, not the CDN.
  // Images stay referenced so the requests are not dropped before they finish.
  const preloaded = new Map();
  function preload(urls) {
    urls.forEach(url => {
      if (!url || preloaded.has(url)) return;
      const image = new Image();
      image.src = url;
      preloaded.set(url, image);
    });
  }
  window.PdpDesignLinks = { resolve, waitImage, finish, preload };
})();
